import FamilyRequests from '../../server/categoryFamilies';
import { addLoading, removeLoading } from './loading';

export const setFamily = family => ({
  type: 'GET_FAMILY',
  family,
});

export const setFamilies = families => ({
  type: 'GET_FAMILIES',
  families,
});

export const setCategories = categories => ({
  type: 'GET_CATEGORIES_FAM',
  categories,
});

export const setCategoryFamilies = categoryfamilies => ({
  type: 'GET_CATEG_FAMILIES',
  categoryfamilies,
});

const createFamily = family => async (dispatch) => {
  dispatch(addLoading());
  try {
    await FamilyRequests.createFamily(family);
  } finally {
    dispatch(removeLoading());
  }
};

const updateFamily = family => async (dispatch) => {
  dispatch(addLoading());
  try {
    await FamilyRequests.updateFamily(family);
  } finally {
    dispatch(removeLoading());
  }
};

const getFamily = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    const family = await FamilyRequests.getFamily(id);
    dispatch(setFamily(family));
  } finally {
    dispatch(removeLoading());
  }
};

const getFamilies = (limit, skip, search, force = false, order = '', field = '') => async (dispatch) => {
  if (!search || force) dispatch(addLoading());
  try {
    const families = await FamilyRequests.getFamilies(limit, skip, search, order, field);
    dispatch(setCategoryFamilies(families[0]));
    dispatch(setCategories(families[2]));
    dispatch(setFamilies(families[1]));
  } finally {
    if (!search || force) dispatch(removeLoading());
  }
};

export const getFamiliesSelect = (search, force = false) => async (dispatch) => {
  if (!search || force) dispatch(addLoading());
  try {
    const families = await FamilyRequests.getFamilies(1000, 0, search, 'ASC', 'id');
    dispatch(setFamilies(families));
  } finally {
    if (!search || force) dispatch(removeLoading());
  }
};

const deleteFamily = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    await FamilyRequests.deleteFamily(id);
  } finally {
    dispatch(removeLoading());
  }
};

export default {
  createFamily,
  getFamily,
  getFamilies,
  updateFamily,
  deleteFamily,
  getFamiliesSelect,
};
